import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD } from '../../../shared/format.js';
import { usePosState } from '../hooks/usePosState.js';

function CartLine({ item }) {
  const setQty = usePosState((s) => s.setQty);
  const setLineDiscount = usePosState((s) => s.setLineDiscount);
  const removeLine = usePosState((s) => s.removeLine);
  const lineGross = item.qty * item.unitPrice;
  const lineTotal = Math.max(0, lineGross - (item.discount || 0));

  return (
    <div className="py-2.5 border-b border-line last:border-b-0">
      <div className="flex items-center gap-2.5">
        <div className="text-[26px] leading-none">{item.emoji || '📦'}</div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-[13px] truncate">{item.name}</div>
          <div className="text-[11px] text-ink-3">{formatIQD(item.unitPrice)} / قطعة</div>
        </div>
        <div className="flex items-center gap-1">
          <button
            type="button"
            className="btn px-2 py-1 text-[14px]"
            onClick={() => setQty(item.productId, item.qty - 1)}
            disabled={item.qty <= 1}
          >
            −
          </button>
          <span className="font-bold min-w-[24px] text-center">{item.qty}</span>
          <button
            type="button"
            className="btn px-2 py-1 text-[14px]"
            onClick={() => setQty(item.productId, item.qty + 1)}
          >
            +
          </button>
        </div>
        <div className="font-extrabold min-w-[68px] text-end text-[13px]">
          {formatIQD(lineTotal)}
        </div>
        <button
          type="button"
          onClick={() => removeLine(item.productId)}
          className="text-red p-1 hover:bg-paper-2 rounded-md"
          title="حذف"
        >
          <Icon name="trash" size={14} />
        </button>
      </div>
      <div className="flex items-center gap-2 mt-1.5 ps-9">
        <label className="text-[11px] text-ink-3">خصم السطر</label>
        <input
          className="input py-1 text-[12px] max-w-[110px]"
          type="number"
          min={0}
          value={item.discount || 0}
          onChange={(e) => setLineDiscount(item.productId, e.target.value)}
        />
      </div>
    </div>
  );
}

export function Cart() {
  const cart = usePosState((s) => s.cart);

  if (cart.length === 0) {
    return (
      <div className="text-center py-10 text-ink-3">
        <Icon name="pos" size={36} color="#D6CFC0" />
        <div className="text-[13px] mt-2">لم تتم إضافة أي منتج بعد</div>
      </div>
    );
  }

  return (
    <div className="px-1">
      {cart.map((it) => (
        <CartLine key={it.productId} item={it} />
      ))}
    </div>
  );
}
